export enum QueryKey {
  ARTICLE = 'ARTICLE',
  ARTICLES = 'ARTICLES',
  ARTICLE_SEARCH = 'ARTICLE_SEARCH',
  ARTICLE_COMMENTS = 'ARTICLE_COMMENTS',
  NEWSFEED_SEEN_BY = 'NEWSFEED_SEEN_BY',
  LIKED_BY = 'LIKED_BY',
}
